import styled from 'styled-components';
import {getColorFromTheme} from '../../../../../../ui/ui-utils';
import {Typography} from '../../../../../../ui/atoms/typography';
import {Button} from '../../../../../../ui/atoms/button';
import {down} from 'styled-breakpoints';

export const GroupTypeWrapper = styled.div`
  border: solid 1px ${getColorFromTheme('borderLight')};
  border-radius: 10px;
`;

export const FirstWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 0px;

  > span {
    display: flex;
    align-items: center;
  }
  ${down('sm')} {
    display: block;
  }
`;

export const SecondWrapper = styled.div`
  border: solid 1px ${getColorFromTheme('borderLight')};
  border-radius: 10px;

  .searchBox {
    padding: 16px;
  }
  .row-container {
    overflow-x: scroll;
  }
  .table-container {
    min-width: 800px;

    &::-webkit-scrollbar {
      width: 2em;
      border-top: 1px solid #ededf2;
      height: 2.1em;
    }
  }
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 67% 20% 10%;
  background: ${getColorFromTheme('backgroundLight')};
  border-top: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px 10px 0 0;
  height: 52px;
  padding: 16px;

  @media (max-width: 768px) {
    min-width: 500px;
  }
`;

export const TableHeaderChild = styled.div`
  display: grid;
  grid-template-columns: 70% 14% 8% 4%;
  grid-gap: 10px;
  padding: 16px;
  border-top: 1px solid ${getColorFromTheme('borderLight')};
  align-items: center;
  height: 68px;

  @media (max-width: 768px) {
    min-width: 500px;
  }

  p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  > button > p > svg {
    width: 10.5px;
    height: 14px;
    margin: 6.4px 9px 8.4px 0;
  }

  button > svg:hover,
  svg:active {
    stroke: ${getColorFromTheme('purple300')};
  }
`;

export const DropdownItem = styled.button`
  ${Typography};
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  cursor: pointer;
  border: none;
  background: none;
  display: block;
  outline: none;
  line-height: 1.7;
  padding: 6px 16px;
  transition: all ease-in-out 200ms;
  color: ${getColorFromTheme('textBody')};

  &:hover {
    background-color: ${getColorFromTheme('backgroundDark')};
    border-radius: 10px;
    color: ${getColorFromTheme('textDark')};
  }
`;

export const ModalWrapper = styled.div`
  max-width: 560px;
  margin: auto;
`;

export const ModalCard = styled.div`
  background: ${getColorFromTheme('white')};
  padding: 80px;
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  @media (max-width: 500px) {
    padding: 40px;
  }
`;

export const LoaderWrapper = styled.div`
  padding: 16px;
  border-top: 1px solid ${getColorFromTheme('borderLight')};
`;

export const CustomButton = styled(Button)`
  padding: 8px 16px;
`;
